module.exports = __webpack_public_path__ + "static/media/clearLight.9f9a2554.svg";